import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import Users from "@insite/mobius/Icons/Users";
import { COLORS } from "@store/theme/common/design";
import { css } from "styled-components";

Object.assign(wishListSharingStatusStyles, {
    sharedIcon: {
        src: Users,
        color: COLORS.link.base,
        size: 18,
        css: css`
            margin-right: 8px;
        `,
    },
});
